<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <transfer-region-create-or-update v-model="transferRegion"></transfer-region-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { TransferRegionApi } from '@/api/transfer-region'
import TransferRegionCreateOrUpdate from './components/TransferRegionCreateOrUpdate.vue'
export default {
    components:{
        BCard,
        TransferRegionCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            fields:[
                {name:'Bölge Kodu',key:'RegionCode',sortable:true, thClass:'w-20'},
                {name:'Bölge Adı',key:'RegionName',sortable:true, thClass:'w-40'},
                {name:'Açıklama',key:'RegionDescription',sortable:true, thClass:'w-40'},
                {name:'Vişne Madencilik Firması',key:'IsOwnFirm',sortable:true, thClass:'w-40'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            transferRegion:{
                Id:null,
                RegionName: null,
                RegionCode: null,
                RegionDescription: null,
                IsOwnFirm: false
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.transferRegion.Id = null
            this.transferRegion.RegionName = null
            this.transferRegion.RegionCode = null
            this.transferRegion.RegionDescription = null
            this.transferRegion.IsOwnFirm = false
        },
        provider(data){
            return TransferRegionApi.Table(data)
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.transferRegion.Id = item.Id
            this.transferRegion.RegionName = item.RegionName
            this.transferRegion.RegionCode = item.RegionCode
            this.transferRegion.RegionDescription = item.RegionDescription
            this.transferRegion.IsOwnFirm = item.IsOwnFirm
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            TransferRegionApi.CreateOrUpdate(this.editing,this.transferRegion).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.RegionName} adlı transfer bölgesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    TransferRegionApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>